<div class="alert-container">
  <mat-icon class="alert-icon">error</mat-icon>
  <p class="alert-message">{{ message }}</p>
</div>
